import dayjs from "dayjs";
import { InputFactoryProp } from "../../../../shared/interfaces";
 
export const getInputsFilter = (): InputFactoryProp[] => {
    return [
        {
            element: 'onlydate',
            placeHolder: 'Año',
            allowClear: true,
            picker: 'year',
            mode: 'year',
            format:'YYYY',
            name: 'year',
        },
        {
            element: 'onlydate',
            placeHolder: 'Mes',
            allowClear: true,
            name: 'month',
            mode: 'month',
            picker: 'month',
            format: 'MM',
            minDate: dayjs().startOf('year'),
            maxDate: dayjs().endOf('year')
        },
        {
            element: 'select',
            placeHolder: 'Quincena',
            allowClear: true,
            items: [
                { value: '1', label: 'Primera' },
                { value: '2', label: 'Segunda' }
            ],
            name: 'fortnight',
        }
    ];
};